<template>
  <div :class="className">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {
      a: ''
    }
  },
  props: {
    className: {
      default: '',
      type: String
    }
  }
}
</script>

<style lang="less" scoped>
@import './../../assets/less/variable.less';
@import './../../assets/less/function_px.less';
// .bgImg(@imgUrl,@scale:1) {
//   @url: '@{imgUrl}?scale=@{scale}';
//   @imgW: unit(image-width(@imgUrl), px) * @scale;
//   @imgH: unit(image-height(@imgUrl), px) * @scale;
//   background-image: url(@url);
//   background-repeat: no-repeat;
//   background-size: 100%;
//   width: @imgW;
//   height: @imgH;
//   display: inline-block;
// }
// .ic-group {
//   .bgImg("../../assets/images/group/group_logo.png", 0.5);
// }
// .ic-group_price {
//   .bgImg("../../assets/images/group/group_price.png", 0.5);
// }
// .ic-group_save {
//   .bgImg("../../assets/images/group/group_save.png", 0.5);
// }
// .ic-group_nothing {
//   .bgImg("../../assets/images/group/group_nothing.png", 0.5);
// }
.icon-price-sort-normal {
  .bgImg('./../../assets/images/price_normal.png', 0.5);
}
.icon-price-sort-up {
  .bgImg('./../../assets/images/price_up.png', 0.5);
}
.icon-price-sort-down {
  .bgImg('./../../assets/images/price_down.png', 0.5);
}
.icon-right {
  .bgImg('./../../assets/images/store/icon_into_gray.png', 0.5);
}
.icon-min-right {
  .bgImg('./../../assets/images/goStore.png', 0.5);
}
.icon-shopping-cart {
  .bgImg('./../../assets/images/add.png', 0.5);
}
.white-triangle {
  .bgImg('./../../assets/images/store/white_triangle.png', 0.5);
}
.min-star-yellow {
  .bgImg('./../../assets/images/star/star_yellow.png', 0.5);
}
.min-star-gray {
  .bgImg('./../../assets/images/star/star_gray.png', 0.5);
}
.mid-star-yellow {
  .bgImg('./../../assets/images/star/mid_star_yellow.png', 0.5);
}
.mid-star-gray {
  .bgImg('./../../assets/images/star/mid_star_gray.png', 0.5);
}
.icon-phone {
  .bgImg('./../../assets/images/bottom-phone.png', 0.5);
}
.icon-qr-code {
  .bgImg('./../../assets/images/coupon/icon_qrcode_blue.png', 0.5);
}
.icon-gold-coupon {
  .bgImg('./../../assets/images/coupon/icon_gold.png', 0.5);
}
.icon-phone-blue {
  .bgImg('./../../assets/images/phone_blue.png', 0.5);
}
.icon-phone-blue-small {
  .bgImg('./../../assets/images/icon_phone_blue_small.png', 0.5);
}
.icon-validStatus {
  display: inline-block;
  height: 14px;
  background-color: #fff7e5;
  border-radius: 2px;
  font-size: 10px;
  line-height: 14px;
  padding: 0 2px;
  color: #ad7300;
}
.icon-expressMoney {
  .icon-validStatus;
}
.icon-enterpriseRole {
  .icon-validStatus;
}
.icon-openPoint {
  .icon-validStatus;
  background-color: #FFC700;
  color: #fff;
}
.icon-discount {
  .icon-validStatus;
  background-color: #FF4B4B;
  color: #fff;
}
.icon-position {
  .bgImg('./../../assets/images/position.png', 0.5);
}
.icon-selected {
  .bgImg('./../../assets/images/selected.png', 0.5);
}
.icon-unselected {
  .bgImg('./../../assets/images/unselected.png', 0.5);
}
.icon-group {
  // .bgImg('./../../assets/images/group/group.png', 0.5);
  .icon-validStatus;
  background-color: #FF7400;
  font-size: 10px;
  padding: 0;
  text-align: center;
  width: 16px;
  color: #fff;
}
.icon-group-master {
  .icon-validStatus;
  background-color: #FF7400;
  font-size: 10px;
  color: #fff;
}
.icon-group-other {
  .icon-group;
  background-color: rgb(65, 163, 255);
}
.icon-group-self {
  .icon-group;
  background-color: rgb(65, 163, 255);
}
.icon-what {
  .bgImg('./../../assets/images/group/what.png', 0.5);
}
.icon-dialog-left-top {
  .bgImg('./../../assets/images/group/left_top.png', 0.5);
}
.icon-dialog-right-top {
  .bgImg('./../../assets/images/group/right_top.png', 0.5);
}
.icon-save {
  .bgImg('./../../assets/images/group/save.png', 0.5);
}
.icon-discounts {
  .bgImg('./../../assets/images/group/discounts.png', 0.5);
}
.icon-share {
  .bgImg('./../../assets/images/share_icon.png', 0.5);
}
.icon-warn {
  .bgImg('./../../assets/images/warn.png', 0.5);
}
.icon-super-shop {
  height: 14px;
  background-color: rgb(135, 9, 9);
  border-radius: 0px;
  font-size: 9px;
  line-height: 14px;
  padding: 0 4px;
  color: #fff;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
.icon-allin-pay {
  .bgImg('./../../assets/images/icon_allInPay.png', 0.5);
}
.icon-wechat-pay {
  .bgImg('./../../assets/images/icon_pay_wechat.png', 0.25);
}
.icon-ali-pay {
  .bgImg('./../../assets/images/icon_pay_ali.png', 0.25);
}
.icon-union-pay {
  .bgImg('./../../assets/images/icon_pay_union.jpg', 0.5);
}
.icon-offline-pay {
  .bgImg('./../../assets/images/icon_pay_offline.png', 0.5);
}
.icon-pay-checked {
  .bgImg('./../../assets/images/icon_pay_checked_b.png', 0.5);
}
.icon-epidemic-news {
  .bgImg('./../../assets/images/icon_epidemic_news.png', 0.5);
}
.icon-epidemic-weiyi {
  .bgImg('./../../assets/images/icon_epidemic_weiyi.png', 0.5);
}
.icon-epidemic-consultation {
  .bgImg('./../../assets/images/icon_epidemic_consultation.png', 0.5);
}
.icon-station-location {
  .bgImg('./../../assets/images/icon_station_location.png', 0.5);
}
.icon-station-phone {
  .bgImg('./../../assets/images/icon_station_phone.png', 0.5);
}
.icon-station-notice {
  border: 1px solid #41a3ff;
  padding: 0 5px;
  .scale-1px(2px, 2px, 2px, 2px);
}
.icon-min-up {
  .bgImg('./../../assets/images/icon_folded_gray_small.png', 0.6);
}
.icon-location-new {
  .bgImg('./../../assets/images/location_32px.png', 0.5);
}
.icon-right-new {
  .bgImg('./../../assets/images/icon_into_gray.png', 0.4);
}
.icon-selected-new {
  .bgImg('./../../assets/images/selected_40px.png', 0.4);
}
.icon-right-white-new {
  .bgImg('./../../assets/images/icon_into_white.png', 0.5);
}
.icon-location-white-new {
  .bgImg('./../../assets/images/icon_location_white.png', 0.35);
}
.icon-pay-for-me {
  .bgImg('./../../assets/images/icon_allInPay.png', 0.5);
}
</style>
